import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Catalog from './pages/Catalog';
import RecipeDetail from './pages/RecipeDetail';
import CookMode from './pages/CookMode';
import PinGate from './pages/PinGate';
import { SiteHeader } from './components/SiteHeader';
import { FontSizeProvider } from './lib/fontSize';
import { StarsProvider } from './lib/stars';
import { ServingsProvider } from './lib/servings';
import { ProgressProvider } from './lib/progress';
import { PlanProvider } from './lib/plan';
import Plan from './pages/Plan';
import { AuthProvider, useAuth } from './lib/auth';
import { ErrorBoundary } from './components/ErrorBoundary';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // braces matter: some Chrome builds return a Promise from scrollTo, and a
    // braceless arrow would hand that to React as the effect "cleanup" — which
    // React then calls as a function on the next route change and crashes
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Gate() {
  const { state } = useAuth();
  if (state === 'checking') {
    // never a blank screen — a stalled network shows the splash, then falls
    // through to the PIN gate via the session-check timeout
    return (
      <main className="flex min-h-dvh items-center justify-center px-6">
        <div className="text-center">
          <h1 className="font-serif text-5xl font-semibold tracking-tight">Cookbook</h1>
          <p className="mt-2 font-sans text-sm text-ink-soft">Opening the book…</p>
        </div>
      </main>
    );
  }
  if (state === 'anon') return <PinGate />;
  return (
    <StarsProvider>
      <ServingsProvider>
      <ProgressProvider>
      <PlanProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/cook/:slug"
            element={<CookMode />}
          />
          <Route
            path="*"
            element={
              <>
                <SiteHeader />
                <Routes>
                  <Route path="/" element={<Catalog />} />
                  <Route path="/recipe/:slug" element={<RecipeDetail />} />
                  <Route path="/plan" element={<Plan />} />
                </Routes>
              </>
            }
          />
        </Routes>
      </BrowserRouter>
      </PlanProvider>
      </ProgressProvider>
      </ServingsProvider>
    </StarsProvider>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <FontSizeProvider>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </FontSizeProvider>
    </ErrorBoundary>
  );
}
